// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__UBQHc","name":"Header_name__3Q9S_","birthday":"Header_birthday__349MF","skeleton":"Header_skeleton__3MnNL"};